"use client"
import "swiper/css"
import colors from "theme/colors"
import { Container, NewText, useIsDesktop } from "ui"
import NumbersGrid, { NumbersGridBackgroundProps } from "ui/NumbersComponent/NumbersGrid"
import { extractProperty } from "utils"

type Props = {
  data: any
  backgroundColors?: NumbersGridBackgroundProps
  showIcons?: boolean
}

export const NumbersContainer: React.FC<Props> = ({ data, backgroundColors, showIcons }) => {
  const numbersData = extractProperty(data, "numbersComponent").map((contentBlock: any) => {
    return {
      title: extractProperty(contentBlock, "title"),
      number: extractProperty(contentBlock, "largeText"),
      textNextToNumber: extractProperty(contentBlock, "textNextToNumber"),
      text: extractProperty(contentBlock, "text"),
    }
  })
  const isDesktop = useIsDesktop()
  const blockTitle = extractProperty(data, "blockTitle")
  const colorPicker = extractProperty(data, "colorPicker")
  const bottomText = extractProperty(data, "bottomText")

  return (
    <div
      className="numbers-grid"
      style={{
        backgroundColor: `#${colorPicker}`,
        marginBottom: isDesktop ? "40px" : "32px",
      }}
    >
      <Container
        style={{
          paddingBottom: isDesktop ? "60px" : "32px",
          paddingTop: isDesktop ? "60px" : "32px",
        }}
      >
        <NewText
          component="p"
          desktopFontSize={40}
          desktopLineHeight="44px"
          mobileFontSize={32}
          mobileLineHeight="36px"
          desktopFontWeight="400"
          color={colors.black}
        >
          {blockTitle}
        </NewText>
        <NumbersGrid
          data={numbersData}
          backgroundColors={backgroundColors}
          textColor="white"
          showIcons={showIcons}
        />
        <NewText component="p" desktopFontSize={16} desktopLineHeight="20px" color={colors.white}>
          {bottomText}
        </NewText>
      </Container>
    </div>
  )
}
export default NumbersContainer
